import { RiderConstants } from '../../../common/js/static/Product';
import { ValidationResult } from '../../angular/interfaces/validation/ValidationInterface';
import { Utils } from '../../../common/js/Utils';
import { CommonUtils } from '../../../common/js/static/CommonUtils';
import type { CoverpathBasePolicy } from '../../../coverpath-common/classes/coverpath_subclasses/CoverpathBasePolicy';

export class ValidationUtils {
  public static isValidGirAge(dateOfBirth: Date): ValidationResult {
    const dob = new Date(dateOfBirth);
    // the min for GIR is 0 so we never check for this
    if (CommonUtils.isOlderThanOrEqualToAge(dob, RiderConstants.gir.maxAge)) {
      return {
        result: false,
        error: `Guaranteed Insurability Rider cannot be added over age ${RiderConstants.gir.maxAge}`,
      };
    }
    return { result: true };
  }

  /**
   * Only a simple checkbox acknowledgement is required when owner == insured, or policy is LB.
   * Otherwise insured consent must be retrieved through email
   */
  public static requiresSimpleInsuredAcknowledgement(
    policy: CoverpathBasePolicy,
    earlyInsuredConsentEnabled: boolean
  ): boolean {
    if (earlyInsuredConsentEnabled && !policy.isLifeBridge() && !this.isConversionPolicy(policy)) {
      return policy.isOwnerSameAsInsuredOrJuvenile();
    } else {
      return true;
    }
  }

  private static isConversionPolicy(policy) {
    return !!policy.convertedFrom;
  }
}
